<template>
  <base-layout>
    <template>
      <ob-layout :type="16">
        <template slot="heading">
          Reporting Employees/Trainees
          <span
            class="span-color"
            v-if="!this.isLoading"
          >{{TraineesCount}}</span>
        </template>
        <template slot="buttons"></template>
        <template slot="placement-left-section">
          <div style="padding-top: 5%;">
            <ob-input
              class="search-bar"
              icon="fa-search"
              placeholder="Search Trainee"
              @input="searchEmployee"
            ></ob-input>
          </div>
          <div v-if="isLoading">
            <ob-spinner loading-text="Loading..."></ob-spinner>
          </div>

          <div v-else class="col-md-12" style="height: 100%;padding: 0;overflow-x: hidden;">
            <div class="row" style="padding-bottom: 15px; margin-bottom: 15px;">
              <div class="col-md-12" id="myInput" v-if="TraineesCount > 0">
                <div class="emp-list clearfix" v-for="(data, index) in EmpList" :key="index">
                  <div
                    class="col-md-12"
                    style="padding-right: 0; cursor: pointer;"
                    :class="{'active-index': index == selectedFileIndex }"
                    @click="onClick(index)"
                  >
                    <div class="media">
                      <div class="media-left media-middle" style="width: 45px;">
                        <img
                          :src="getProfilePic(data && data.ProfilePic ? data.ProfilePic :'')"
                          style="width:35px;height:35px;border-radius:50%;"
                        />
                      </div>
                      <div class="media-body">
                        <div>
                          <span
                            class="placed-name" style="line-height: 1;"
                          >
                            <span :title="NAOrValue(data,'Name')" class="text_Namefol" style="display:inline-block;max-width:160px !important;">{{NAOrValue(data, "Name")}}</span>
                            <span v-if="data.IsTrainee" v-tooltip="'Trainee'" class="trainee-span">T</span>
                          </span>
                        </div>

                        <div>
                          <p
                            style="display: inline ;  font-size: 11px;"
                            class="placed-job text_Namefol"
                          >{{NAOrValue(data, "Designation")}} |</p>
                          <span
                            style="display: inline ;  font-size: 11px;"
                            class="placed-job text_Namefol"
                          >{{NAOrValue(data, "Workpermit")}} |</span>
                          <span
                            style="display: inline ;  font-size: 11px;"
                            class="placed-job text_Namefol"
                          >{{ data.IsEssEnabled ? 'ESS Enabled' : 'ESS Disabled'}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <p
                  style="margin-top: 20%;margin-left: 10%;color: red;font-size: 15px;font-weight: 800;"
                >Assigned Trainees are not available</p>
              </div>
            </div>
          </div>
        </template>
        <template slot="top-right-section">
          <div class="row" v-if="TraineesCount > 0">
            <div class="col-md-12" style="margin-top:15px">
              <div class="col-md-1">
                <img
                  :src="getProfilePic(selectedFile && selectedFile.ProfilePic ? selectedFile.ProfilePic :'')"
                  style="width:35px;height:35px;border-radius:50%;"
                />
              </div>
              <div class="col-md-2" style="padding: 0;">
                <span
                  class="emp-name span-text"
                  :title="NAOrValue(selectedFile,'Name')"
                >{{NAOrValue(selectedFile,"Name")}}</span>
                <span
                  class="des-text span-text"
                  :title="NAOrValue(selectedFile,'Designation')"
                >{{NAOrValue(selectedFile,"Designation")}}</span>
              </div>
              <div class="col-md-2">
                <span class="span-text">Work Auth type</span>
                <span
                  class="des-text span-text"
                  :title="NAOrValue(selectedFile,'Workpermit')"
                >{{NAOrValue(selectedFile,"Workpermit")}}</span>
              </div>
              <div class="col-md-3">
                <span class="span-text">Email ID</span>
                <span
                  class="des-text span-text"
                  :title="NAOrValue(selectedFile,'Email')"
                >{{NAOrValue(selectedFile,"Email")}}</span>
              </div>
              <div class="col-md-2">
                <span class="span-text">End Client</span>
                <span
                  class="des-text span-text"
                  :title="NAOrValue(selectedFile,'EndClient')"
                >{{NAOrValue(selectedFile,"EndClient")}}</span>
              </div>
              <div class="col-md-2">
                <span class="span-text">Current Project</span>
                <span
                  class="des-text span-text"
                  :title="NAOrValue(selectedFile,'jobTitle')"
                >{{NAOrValue(selectedFile,"jobTitle")}}</span>
              </div>
            </div>
          </div>
        </template>

        <template slot="bottom-right-section" v-if="TraineesCount > 0">
          <template>
            <div class="emp-header_tabs">
              <ul>
                <li
                  
                  :class="{activeTab: $route.name == 'supervisor-form-i983'}"
                >
                  <router-link
                    :to="{name:'supervisor-form-i983', query:{EmployeeId:TraineeEmployeeId,ConsultantId:ConsultantId}}"
                  >
                    <span>FORM I-983</span>
                  </router-link>
                </li>
                <li :class="{activeTab: $route.name == 'employee-tasks-trainee'}">
                  <router-link
                    :to="{name:'employee-tasks-trainee', query:{EmployeeId:TraineeEmployeeId,from:'ReportingEmployee'}}"
                  >
                    <span>TASKS</span>
                  </router-link>
                </li>
                <li :class="{activeTab: $route.name == 'employee-evaluation-trainee'}">
                  <router-link
                    :to="{name:'employee-evaluation-trainee', query:{EmployeeId:TraineeEmployeeId}}"
                  >
                    <span>EVALUATION</span>
                  </router-link>
                </li>
                <li :class="{activeTab: $route.name == 'employee-LeaveReport-trainee'}">
                  <router-link
                    :to="{name:'employee-LeaveReport-trainee', query:{EmployeeId:TraineeEmployeeId}}"
                  >
                    <span>LEAVE REPORT</span>
                  </router-link>
                </li>
              </ul>
              <!-- <span @click="generateReport()" style="float:right;margin-right: 10px;"><ob-button type="secondary" v-if="$route.name == 'employee-evaluation-trainee'">Generate Report</ob-button></span> -->
            </div>
            <!-- <generate-report :EmployeeId.sync="TraineeEmployeeId" :show.sync="showgeneratePopup"></generate-report> -->
          </template>
          <div class="form-i983-details">
            <router-view :isSupervisor="true"></router-view>
          </div>
          <!-- </div> -->
        </template>
      </ob-layout>
    </template>
  </base-layout>
</template>
<script>
import FormI983 from "./FormI983.vue";
import c from "Vue/Core/constants.js";
//import GenerateReport from './Timesheets/GenerateReport.vue'

export default {
  data() {
    return {
      TraineeEmployeeId: "",
      ConsultantId:"",
      isLoading: true,
      // showgeneratePopup : false,
      showFilter: false,
      workAuthFilterTypes: [],
      selectedFileIndex: 0,
      EmpList: [],
      routerFormI983: {
        name: "supervisor-form-i983",
        query: this.$route.query
      },
      routerFormTasks: {
        name: "employee-tasks-trainee",
        query: { from: "ReportingEmployee" }
      },
      routerFromEvalaution: {
        name: "employee-evaluation-trainee",
        query: this.$route.query
      },
      routerFromLeaveReport: {
        name: "employee-LeaveReport-trainee",
        query: this.$route.query
      }
    };
  },
  components: {
    fromi983: FormI983
    //  "generate-report": GenerateReport
  },
  created() {
    this.getEmployeeList();
  },
  methods: {
    customRoutTo() {
      var empId = this.TraineeEmployeeId;
      var conId = this.ConsultantId;
      var workpermit = this.selectedFile.Workpermit;
      if (
        workpermit == "CPT" ||
        workpermit == "STEM OPT" ||
        workpermit == "OPT EAD"
      ) {
        this.$router.push({
          name: "supervisor-form-i983",
          query: { EmployeeId: empId,ConsultantId :conId }
        });
      } else {
        this.$router.push({
          name: "employee-tasks-trainee",
          query: { EmployeeId: empId, from: "ReportingEmployee" }
        });
      }
    },
    //   generateReport()
    //  {
    //  this.showgeneratePopup = true
    //   },
    searchEmployee(val) {
      var filter = val.toUpperCase();
      var parentDiv = document.getElementById("myInput");
      if(parentDiv != undefined && parentDiv != null)
      {
        var list = parentDiv.getElementsByClassName("emp-list");
        for (var i = 0; i < list.length; i++) {
          var a = list[i].getElementsByTagName("a")[0];
          var p = list[i].getElementsByTagName("span")[0];
          var studentName = a.textContent || a.innerText;
          var workAuth = p.textContent || p.innerText;
          if (
            studentName.toUpperCase().indexOf(filter) > -1 ||
            workAuth.toUpperCase().indexOf(filter) > -1
          ) {
            list[i].style.display = "";
          } else {
            list[i].style.display = "none";
          }
        }
      }
    },
    onClick(index) {
      this.selectedFileIndex = index;
      this.TraineeEmployeeId = this.selectedFile.EmployeeId;
      this.ConsultantId = this.selectedFile.ConsultantId;
      this.customRoutTo();
    },
    getProfilePic(ProfilePicLink) {
      if (ProfilePicLink != null && ProfilePicLink != "") return ProfilePicLink;
      else return `${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/noimage.svg`;
    },
    getEmployeeList() {
      var routeParam = this.$route.query.EmployeeId;
      this.isLoading = true;
      ajax.get(
        `/Supervisor/GetReportingEmployeeList?empId=${this.EmployeeId}`,
        {},
        res => {
          if (res.data.resultList.length > 0) {
            this.EmpList = res.data.resultList;
            if (routeParam != null) {
              var index = this.EmpList.findIndex(d => {
                return d.EmployeeId == routeParam;
              });
              this.selectedFileIndex = index;
              if (index > -1) {
                this.TraineeEmployeeId = this.selectedFile.EmployeeId;
                this.ConsultantId = this.selectedFile.ConsultantId;

                if (this.$route.name == "employee-tasks-trainee") {
                  this.$router.push({
                    name: this.$route.name,
                    query: {
                      EmployeeId: routeParam,
                      from: "ReportingEmployee",
                      isListview: this.$route.query.isListview
                    }
                  });
                } else {
                  this.$router.push({
                    name: this.$route.name,
                    query: { EmployeeId: routeParam ,ConsultantId : this.ConsultantId}
                  });
                }
              }
            } else {
              this.onClick(0);
            }
            this.isLoading = false;
          } else {
            this.TraineeEmployeeId = "N/A";
            this.isLoading = false;
            this.ESSEnableDisable(res);
          }
        }
      );
    }
  },
  computed: {
    isI983Visible() {
      if (this.selectedFile && this.selectedFile.Workpermit) {
        var workpermit = this.selectedFile.Workpermit;
        //  if ( workpermit == "CPT" || workpermit == "STEM OPT" || workpermit == "OPT EAD" )
        {
          return true;
        }
        //else return false
      } else return false;
    },
    EmployeeId() {
      return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : "";
    },
    TraineesCount() {
      return this.EmpList.length;
    },
    selectedFile: {
      get() {
        return this.EmpList[this.selectedFileIndex];
      },
      set(v) {
        Vue.set(this.EmpList, this.selectedFileIndex, v);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~styles/framework/vue-utils";

.active-index {
  background: #f0f7ff;
  border-left: 3px solid #59a2e7;
}
.active-index .placed-name {
  color: #337ab7 !important;
}
.active-index p,
.active-index span {
  font-weight: 600;
}

.emp-list {
  border-bottom: 1px solid #edeef0;
  .media-body {
    padding-bottom: 3%;
    display: table-cell;
    .placed-name {
      color: black;
      font-size: 15px;
      font-weight: 600;
      margin: 10px 0 0 0;
      max-width: 100%;
      cursor: pointer;
      display: inline-block;
    }
    .placed-job {
      color: $ob-brand-primary;
      font-size: 12px;
      width: 180px;
    }
  }
}
.emp-header_tabs {
  min-height: 34px;
  margin: 10px 0 0 0;
  border-bottom: 1px solid #dfdfdf;
  ul {
    padding: 0;
    width: 60%;
    display: inline-block;
    margin-top: 5px;
    li {
      margin-left: 5%;
      list-style: none;
      display: inline;
      padding: 7px 10px 8px 10px;
      a {
        font-size: 13px;
        font-weight: 600;
        color: #b0b2b5;
      }
    }
    li.activeTab {
      border-bottom: 3px solid #2d4972;
      a {
        color: #143361;
      }
    }
  }
}
.emp-name {
  font-size: 14px;
  font-weight: 600;
  color: #337ab7 !important;
}
.des-text {
  font-size: 14px;
  font-weight: 600;
}
.header_tabs {
  width: 100%;
}
.form-i983-details {
  overflow: auto;
  height: 90%;
  margin: 10px;
  margin-right: 0;
  margin-top: 0;
}
.consultant_header_tabs {
  width: 100%;
}
.span-text {
  float: left;
  clear: left;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.search-bar {
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 2%;
}
.filter-by-tax-term {
  p {
    color: #333;
    padding-bottom: 5px;
  }
}
.trainee-span {
  background-color: #3ec1a3;
  color: white;
  font-size: 12px;
  border-radius: 10px;
  padding: 6px 6px 5px 6px;
  font-weight: 800;
  margin-left: 6px;
  float: right;
  line-height: 0.5;
}
.span-color {
  background: #fed4de;
  color: #dd3d64;
  border-radius: 10px;
  padding: 2px 11px;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/ReportingEmployees.vue